import React from 'react';
import { HelpCircle, MessageSquare, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';

import { useTranslation } from '../hooks/useTranslation';

const FAQ = () => {
  const { t, isBrazil } = useTranslation();
  const categories = [
    {
      title: t.catGeneral,
      questions: [
        { q: t.faqWhatIsPlataPost, a: t.faqWhatIsPlataPostAns },
        { q: t.faqWhoIsPlataPostFor, a: t.faqWhoIsPlataPostForAns },
        { q: t.faqIsPlataPostGoodForAgencies, a: t.faqIsPlataPostGoodForAgenciesAns }
      ]
    },
    {
      title: t.catHowItWorks,
      questions: [
        { q: t.faqCanPlataPostWritePosts, a: t.faqCanPlataPostWritePostsAns },
        { q: t.faqBrandVoice, a: t.faqBrandVoiceAns },
        { q: t.faqCanIEditContent, a: t.faqCanIEditContentAns }
      ]
    },
    {
      title: t.catPricingSupport,
      questions: [
        { q: t.faqHowMuchDoesItCost, a: t.faqHowMuchDoesItCostAns },
        { q: t.faqDoesPlataPostSchedule, a: t.faqDoesPlataPostScheduleAns },
        { q: t.faqPlatforms, a: t.faqPlatformsAns }
      ]
    }
  ];

  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title={`${isBrazil ? 'FAQ' : 'Frequently Asked Questions'} - PlataPost`}
        description={t.faqHeroSubtitle}
      />

      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-24 space-y-4">
          <p className="text-indigo-500 font-bold uppercase tracking-widest text-sm">
            FAQ
          </p>
          <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">
            {isBrazil ? "Perguntas" : "Frequently Asked"} <span className="text-indigo-500">{isBrazil ? "Frequentes" : "Questions."}</span>
          </h1>
          <p className="text-xl text-gray-400 font-medium">
            {t.faqHeroSubtitle}
          </p>
        </div>

        <div className="space-y-16 mb-32">
          {categories.map((category) => (
            <div key={category.title} className="space-y-8">
              <h2 className="text-2xl font-black text-white border-b border-white/10 pb-6 flex items-center gap-4 tracking-tight">
                <div className="w-10 h-10 rounded-xl bg-indigo-500/10 flex items-center justify-center border border-indigo-500/20">
                  <HelpCircle className="w-5 h-5 text-indigo-400" />
                </div>
                <span>{category.title}</span>
              </h2>
              <div className="grid gap-6">
                {category.questions.map((item, i) => (
                  <div key={i} className="glass-card p-8 rounded-[2.5rem] border border-white/5 hover:border-white/10 transition-all group">
                    <h3 className="text-lg font-black text-white mb-4 flex items-start gap-4 tracking-tight">
                      <span className="text-indigo-500">Q:</span>
                      {item.q}
                    </h3>
                    <div className="text-gray-400 leading-relaxed pl-9 font-medium">
                      {item.a}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="glass-card rounded-[3.5rem] p-12 lg:p-20 text-center border border-white/5 relative overflow-hidden group">
          <div className="absolute inset-0 bg-gradient-to-b from-indigo-600/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          
          <div className="relative z-10">
            <div className="w-20 h-20 bg-white/5 rounded-3xl flex items-center justify-center mx-auto mb-8 border border-white/10 group-hover:scale-110 transition-transform">
              <MessageSquare className="w-10 h-10 text-indigo-400" />
            </div>
            <h2 className="text-3xl lg:text-4xl font-black text-white mb-6 tracking-tighter">{t.stillHaveQuestions}</h2>
            <p className="text-gray-400 mb-10 max-w-lg mx-auto text-lg font-medium">
              {t.stillHaveQuestionsDesc}
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-3 px-10 py-5 bg-indigo-600 text-white rounded-2xl font-black hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-600/20 group/btn"
            >
              <span>{t.contactSupport}</span>
              <ArrowRight className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
